import React from 'react';
import { City } from './lawyerSnippet.types';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './RestrictToLawyerContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { VillesChart } from '../../../../../entity/charts/villes/VillesChart';
import { VillesChartContainer } from '../../../../../entity/charts/villes/VillesChartContainer';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { EnhanceVilleChart } from '../../../../../entity/charts/villes/EnhanceVilleChart';
import { ChartDecisionLegend } from '../../../../../entity/charts/legend/ChartLegend';

type Props = {
  lawyerId: string;
  lawyerName: string;
  villes: Array<City>;
  url: string;
  source: string;
} & PropsFromRedux &
  WithRestrictedModalProps &
  UserContextType;

class RawVilleTab extends React.Component<Props> {
  filterSearch = (source: string) => (
    wantToOpenInNewTab: boolean,
    ville: City | null,
  ) => {
    const { accessPremium, onRestrictToLawyer } = this.props;
    const clickedSource = `${this.props.source}-${source}`;
    if (accessPremium) {
      const data = {
        lawyerName: this.props.lawyerName,
        lawyerId: this.props.lawyerId,
        ville: ville ? ville.key : undefined,
        type: 'ville',
      };
      doctrineAnalytics('Search ChartSnippetClicked', data);
      onRestrictToLawyer(data);
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  render() {
    return (
      <div className="enterprise-snippet__panel">
        <VillesChartContainer villes={this.props.villes}>
          {({ sortedVilles }) => (
            <>
              <EnhanceVilleChart
                villes={sortedVilles}
                handleClick={this.filterSearch('villes_chart')}
              >
                {({ data, labels, handleClick }) => (
                  <VillesChart
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                  />
                )}
              </EnhanceVilleChart>
              <EnhanceVilleChart
                villes={sortedVilles}
                handleClick={this.filterSearch('villes_legend')}
              >
                {({ data, labels, handleClick, baseH }) => (
                  <ChartDecisionLegend
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                    baseH={baseH}
                    limit={3}
                  />
                )}
              </EnhanceVilleChart>
            </>
          )}
        </VillesChartContainer>
      </div>
    );
  }
}

export const VilleTab = withUser(Connect(withRestrictedModal(RawVilleTab)));
